import { DisclosureDexie, getDexieConnectionRefresh } from "./Dexie";
import {
    DisclosureCatalogue,
    DisclosureClip,
    catalogueClips,
    clipId,
} from "JS/Models/Disclosure";

export const catalogueClipIds = (catalogue?: DisclosureCatalogue) =>
    catalogueClips(catalogue).map(clipId);

export const getDisclosureClip = async (id: string) =>
    id ? await getDexieConnectionRefresh().disclosures.get(id) : undefined;

export const getClipBlob = async (clip?: DisclosureClip) => {
    const stored = await getDisclosureClip(clipId(clip));
    return stored?.blob;
};

export const putDisclosureClip = async (clip: DisclosureDexie) =>
    await getDexieConnectionRefresh().disclosures.put(clip);

export const getStoredClipIds = async () =>
    (await getDexieConnectionRefresh().disclosures.toArray()).map((c) => c.id);

export const deleteSupersededClips = async (keepIds: string[]) => {
    const stored = await getStoredClipIds();
    const superseded = stored.filter((id) => !keepIds.includes(id));

    if (superseded.length)
        await getDexieConnectionRefresh().disclosures.bulkDelete(superseded);

    return superseded;
};
